import BackButton from './back-button';
import { Avatar, AvatarFallback, AvatarImage } from '@design-system/avatar';
import SettingsHeaderActions from './settings-header-actions';
import { Button } from '@design-system/button';
import { Buildings, Edit } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
import { createRoute } from '@src/core/router/paths';
import type { TOrganization } from '@shared/types/organization';
import { Text } from '@design-system/text';
import { HasPermission } from '@src/features/roles/guards/has-permission';
import { entities } from '@shared/constants/entities';

export function SettingsHeader({
  organization,
}: {
  organization: TOrganization;
}) {
  const navigate = useNavigate();
  const photo = organization.avatar;
  const fallback = organization.name.substring(0, 1);

  return (
    <div className='flex justify-between items-center my-6 px-5 '>
      <div className='flex items-center gap-2'>
        <BackButton />

        <div className='flex items-center gap-2'>
          <div
            className='relative max-w-15'
            // onClick={() => uploadRef.current?.click()}
          >
            <Avatar className='size-16 border border-gray-100'>
              <AvatarImage src={photo} />
              <AvatarFallback
                className='text-2xl'
                colorId={organization.id}
              >
                {fallback}
              </AvatarFallback>
            </Avatar>
            <Buildings
              size='24'
              className='absolute bottom-0 right-0 p-1 z-10 bg-white rounded-full'
              cursor='pointer'
              variant='Bold'
              color='var(--color-gray-800)'
            />
          </div>

          <div className='flex flex-col items-start text-gray-800  truncate'>
            <Text className='font-medium text-primary-800 text-lg'>
              <span>{organization.name}</span>
              <span className='font-light text-primary-600 text-sm ms-1 align-text-top'>
                {organization?.formatted_sharable_uid ?? organization.id}
              </span>
            </Text>
            <Text className='font-normal text-secondary-1000 text-sm'>
              {organization.country?.name}
            </Text>
          </div>
        </div>
      </div>

      <div className='flex gap-2'>
        <HasPermission
          action='change'
          entity={entities.organization}
        >
          <Button
            variant='primaryOutline'
            size='sm'
            onClick={() =>
              navigate(createRoute(`/settings/${organization.id}/edit`))
            }
          >
            <Edit />
            Edit Organization Profile
          </Button>
        </HasPermission>
        <SettingsHeaderActions />
      </div>
    </div>
  );
}
